export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_fragment_1.3b66b6cf.jpg";